import Carousel from '../components/product-carousel';
import { docReady } from '../utils/docReady';
import { isEnabled, getHistory } from '../utils/cartHistoryUtil';
const MAX_PRODUCTS = 8;
const escapeHtml = (value) => {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
};
const buildTile = (product, addToCartCta, shopNowLabel) => {
    var _a;
    const metafields = product.metafields || {};
    const currentVariant = product.current_variant || (product.variants || [])[0] || {};
    const strings = (window.theme || {}).strings || {};
    const addToCartLabel = strings.addToCart || 'Add to cart';
    const soldOutLabel = strings.soldOut || 'Sold out';
    const addedToCartToast = ((_a = (dataJs || {}).product) === null || _a === void 0 ? void 0 : _a.addToCartToast) || 'Added to cart';
    const url = product.collection_url || product.url;
    const wrapper = document.createElement('div');
    wrapper.className = 'product-grid__product swiper-slide';
    wrapper.innerHTML = `
    <a href="${url}" class="product-grid__product--image lazyload">
      ${product.featured_image && product.featured_image.url ? `<img class="lazyload" src="${product.featured_image.url}" alt="${escapeHtml(product.title)}">` : ''}
      <div class="collection__product-tag add-again-tag"><span>Add Again</span></div>
    </a>
    <div class="product-grid__product--details">
      <a class="product-grid__product--title no-spacing" href="${url}">
        <h4>${escapeHtml(product.title)}</h4>
      </a>
      ${metafields.byline ? `<div class="collection__product-byline">${escapeHtml(metafields.byline)}</div>` : ''}
      <p class="product-grid__product--price">${product.price_varies ? 'From ' : ''}${product.formatted_price}</p>
      <div class="product-grid__product--button">
        ${addToCartCta === 'add_to_cart'
        ? product.is_available
            ? `<add-to-cart-button role="button" type="submit" name="add" class="product-add button" data-add-to-cart-label="${escapeHtml(addToCartLabel)}" data-added-to-cart-toast="${escapeHtml(addedToCartToast)}" data-addtobag-button data-product-title="${escapeHtml(product.title)}" data-product-variant-price="${currentVariant.price}" data-product-variant-id="${currentVariant.id}">
                  <div class="product-add__default" data-add-to-cart-button-label>
                    <span class="product-add__text">${escapeHtml(addToCartLabel)}</span>
                  </div>
                  <div class="product-add__loading"></div>
                  <div class="product-add__added">
                    <span class="product-add__added-text">${escapeHtml(addedToCartToast)}</span>
                  </div>
                </add-to-cart-button>`
            : `<a href="${url}" class="button">${escapeHtml(soldOutLabel)}</a>`
        : `<a href="${url}" class="button">${escapeHtml(shopNowLabel)}</a>`}
      </div>
    </div>
  `;
    return wrapper;
};
let mounted = false;
const tryMount = () => {
    if (mounted) {
        return;
    }
    const section = document.querySelector('[data-section-type="usual-picks-carousel"]');
    if (!section || !isEnabled()) {
        return;
    }
    const history = getHistory();
    if (!history.length) {
        return;
    }
    mounted = true;
    const picks = history.slice(0, MAX_PRODUCTS);
    Promise.all(picks.map((pick) => fetch(`/products/${pick.handle}?view=usual-picks-data`)
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null))).then((products) => {
        const availableProducts = products.filter(Boolean);
        if (!availableProducts.length) {
            return;
        }
        const productsRoot = section.querySelector('[data-usual-picks-products]');
        if (!productsRoot) {
            return;
        }
        const { addToCartCta, shopNowLabel } = section.dataset;
        availableProducts.forEach((product) => {
            productsRoot.appendChild(buildTile(product, addToCartCta, shopNowLabel || 'Shop now'));
        });
        section.classList.add('has-usual-picks');
        const { desktopCount, mobileCount, sectionId } = section.dataset;
        const slides = availableProducts.length;
        const swiperContainer = section.querySelector('[data-swiper-container]');
        // swiperContainer is only rendered by the section when Mobile Carousel or Desktop Carousel
        // is enabled in settings (same as sections/product-grid.liquid) - otherwise skip Swiper entirely.
        if (slides > 1 && swiperContainer) {
            const swiperNext = `[data-section-id="${sectionId}"] .swiper-button-next`;
            const swiperPrev = `[data-section-id="${sectionId}"] .swiper-button-prev`;
            // eslint-disable-next-line no-new
            new Carousel(swiperContainer, slides, swiperNext, swiperPrev, Number(desktopCount), Number(mobileCount), {
                centerInsufficientSlides: true,
                // Redeclares slidesPerView alongside spaceBetween because this object fully replaces
                // Carousel's own `breakpoints` (object spread overwrites the whole key, not a merge).
                breakpoints: {
                    0: { slidesPerView: Number(mobileCount), spaceBetween: 8 },
                    1023: { slidesPerView: Number(desktopCount), spaceBetween: 24 },
                    1440: { slidesPerView: Number(desktopCount), spaceBetween: 48 },
                },
            }, 
            // Always run Swiper regardless of viewport width, unlike Carousel's default behavior
            // (which skips Swiper on desktop widths for 2-3 slides) - needed so mouse drag-to-swipe
            // and centering both work consistently at every screen size, not just mobile/tablet.
            true);
        }
    });
};
docReady(() => {
    tryMount();
    if (mounted) {
        return;
    }
    // Convert.com's variation script (document.body.classList.add('usual-picks-enabled'))
    // can run after this point - loaded async, timing isn't guaranteed relative to DOMContentLoaded.
    // Keep watching for the flag to appear instead of checking only once.
    const observer = new MutationObserver(() => {
        tryMount();
        if (mounted) {
            observer.disconnect();
        }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // Convert may have added the class between tryMount() and observe().
    tryMount();
    if (mounted) {
        observer.disconnect();
        return;
    }
    // Safety net: stop watching after 15s so this doesn't run forever on pages where the
    // flag never gets added (flag genuinely off, or no history).
    setTimeout(() => observer.disconnect(), 15000);
});
